import * as _nodeResolve_empty from './_node-resolve_empty.js';
import { getAugmentedNamespace } from './_commonjsHelpers.js';

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty);

export { require$$0 as default };
